import { useEffect, useState } from 'react';

/* Text that types itself once its section plays.
   reveal "wait" -> empty, "play" -> types from `start` ms at `speed` ms per
   character, "done" -> full text at once. The untyped tail is rendered
   invisible, so the line never reflows while it types. */
export default function Typed({ text, reveal, start = 0, speed = 30, caret = true, className = '' }) {
  const [n, setN] = useState(reveal === 'done' ? text.length : 0);

  useEffect(() => {
    if (reveal === 'done') {
      setN(text.length);
      return undefined;
    }
    if (reveal !== 'play') {
      setN(0);
      return undefined;
    }
    let i = 0;
    let iv = null;
    const to = setTimeout(() => {
      iv = setInterval(() => {
        i += 1;
        setN(i);
        if (i >= text.length) clearInterval(iv);
      }, speed);
    }, start);
    return () => {
      clearTimeout(to);
      if (iv) clearInterval(iv);
    };
  }, [reveal, text, start, speed]);

  const typing = caret && reveal === 'play' && n < text.length;
  return (
    <span className={`cxs-typed ${className}`}>
      {text.slice(0, n)}
      {typing ? <span className="cxs-caret" aria-hidden="true" /> : null}
      <span className="cxs-ghost" aria-hidden="true">{text.slice(n)}</span>
    </span>
  );
}
